export enum DonorPreselectReviewStatus {
    NeedsMedicalReview = 1,
    NeedsSurgicalReview = 2,
    NeedsHlaReview = 3,
    NeedsCoordinatorReview = 4
}